import React, { useState, useEffect } from 'react';
import { getPatientLogs } from '../../../api/Patient';
import GoalIcon from '../../Icons/GoalIcon';
import ModuleIcon from '../../Icons/ModuleIcon';
import PointIcon from '../../Icons/PointIcon';
import SurveyIcon from '../../Icons/SurveyIcon';
import './PatientActivity.css';
import ReactDOM from 'react-dom';

function PatientActivity({ patient, activeProject }) {
  let previousDate = new Date().getDate();
  const [showSurveyModal, setShowSurveyModal] = useState(false);
  const [selectedSurveyData, setSelectedSurveyData] = useState(null);
  const [activityLogs, setActivityLogs] = useState([]);

  useEffect(() => {
    const projectId = activeProject?.Id;
    getPatientLogs(patient.Id, projectId)
      .then((result) => {
        console.log("result: ", result);
        const sortedLogs = result.data.sort((a, b) => 
        new Date(b.DateModified) - new Date(a.DateModified)
      );
      console.log("sortedLogs: ", sortedLogs);
      setActivityLogs(sortedLogs);
      })
      .catch((err) => console.log(err));
  }, [patient]);
  const handleOpenSurveyDetails = (log) => {
    // Extract questions and sort them by Id in ascending order
    const sortedQuestions = (log.UserActivity?.Activity?.Questions || []).sort((a, b) => {
      return parseInt(a.Id) - parseInt(b.Id);
    });

    const surveyInfo = {
      title: log.UserActivity?.Activity?.Title,
      description: log.UserActivity?.Activity?.ShortDescription,
      questions: sortedQuestions, // Use the sorted array here
      answers: log.UserActivity?.SurveyResponseAnswers || []
    };

    console.log("surveyInfo with sorted questions: ", surveyInfo);
    setSelectedSurveyData(surveyInfo);
    setShowSurveyModal(true);
  };
  // 2. Define the Modal JSX as a variable or sub-component
 const SurveyModal = () => (
    <div className="survey-modal-overlay">
      <div className="survey-modal-container">
        <div className="survey-modal-header">
          <div>
            <span className="survey-badge">Survey Details</span>
            <h2 className="survey-modal-title">{selectedSurveyData?.title}</h2>
          </div>
          <button className="survey-modal-close" onClick={() => setShowSurveyModal(false)}>
            &times;
          </button>
        </div>
        
        <div className="survey-modal-body">
          {selectedSurveyData?.description && (
            <div className="survey-description-section">
              {/* Bold Title for Description */}
              <label className="section-label">Survey Description</label>
              <div className="description-box">
                {selectedSurveyData.description}
              </div>
            </div>
          )}

          <div className="survey-questions-list">
            {selectedSurveyData?.questions.map((question, index) => {
              const answerObj = selectedSurveyData.answers.find(
                (ans) => ans.SurveyQuestionId === question.Id
              );
              
              return (
                <div key={question.Id} className="survey-question-card">
                  <div className="question-header">
                    <span className="question-number">{index + 1}</span>
                    <p className="question-text">{question.QuestionText}</p>
                  </div>
                  <div className="answer-container">
                    {/* Bold Title for Response */}
                    <label className="section-label">Patient Response</label>
                    <div className="answer-box">
                      {answerObj ? answerObj.Answer : 'No response provided'}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
  return (
    <div className='mt-5'>
      <div className='activityList'>
        <h5>Today</h5>
        <div className='row'>
          <div className='ms-2 d-flex vertical-line'>
            <div className='line'></div>
          </div>
        </div>
        {activityLogs?.map((currentLog) => {
          const currentLogDate = new Date(currentLog?.DateModified);
          if (previousDate === currentLogDate?.getDate()) {
            previousDate = currentLogDate?.getDate();

            return (
              <div key={currentLog?.Id}>
                <LogComponent 
                  log={currentLog} 
                  onOpenDetails={() => handleOpenSurveyDetails(currentLog)} 
                />
              </div>
            );
          } else {
            previousDate = currentLogDate?.getDate();

            return (
              <div key={currentLog?.Id}>
                <div style={{ marginBottom: '1%', marginTop: '1%' }}>
                  <h5>{currentLogDate?.toDateString()}</h5>
                </div>
                <div className='row'>
                  <div className='ms-2 d-flex vertical-line'>
                    <div className='line'></div>
                  </div>
                </div>
                <LogComponent 
                  log={currentLog} 
                  onOpenDetails={() => handleOpenSurveyDetails(currentLog)} 
                />
              </div>
            );
          }
        })}
      </div>
      {/* Full Screen Popup / Modal */}
      {showSurveyModal && ReactDOM.createPortal(<SurveyModal />, document.body)}
    </div>
  );
}

const LogComponent = ({ log, onOpenDetails }) => {
  const renderLogText = () => {
    const baseText = log?.LogType === 'point' && log?.PointEarningHistory?.Activity?.Title
      ? `${log.LogText} for (${log.PointEarningHistory?.Activity.Title}) Activity`
      : log?.LogText;

    // Condition: Survey Type (0) and text contains "started"
    const isSurveyStarted = 
      log?.LogType === 'userActivity' && 
      log?.UserActivity?.Activity?.ActivityType === '0' && 
      log?.LogText?.toLowerCase().includes('started');
    if (isSurveyStarted) {
      return (
        <>
          {baseText}{' '}
          <span 
            className="survey-details-link" 
            onClick={onOpenDetails}
            style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
          >
            open survey details
          </span>
        </>
      );
    }

    return baseText;
  };
  return (
    <div>
      <div className='row'>
        <div className='col'>
          {log?.LogType === 'point' && <PointIcon />}
          {log?.LogType === 'userActivity' &&
            log?.UserActivity?.Activity?.ActivityType === '0' && <SurveyIcon />}
          {log?.LogType === 'userActivity' &&
            log?.UserActivity?.Activity?.ActivityType === '1' && <GoalIcon />}
          {log?.LogType === 'userActivity' &&
            log?.UserActivity?.Activity?.ActivityType === '2' && <ModuleIcon />}
        </div>
        <div className='col-9'>
          <p>{renderLogText()}</p>
        </div>
      </div>
      <div className='row'>
        <div className='ms-2 d-flex vertical-line'>
          <div className='line'></div>
        </div>
      </div>
    </div>
  );
};

export default PatientActivity;